import { constants, typographyStyles } from "@newsela/angelou";

const { heading5Obj, textMObj } = typographyStyles;
const greyDark = constants.colors.ui.neutral[600];

export const rootCss = {
  display: "flex",
  flexFlow: "column",
  justifyContent: "center",
  height: "100%",
  textAlign: "center",
};

export const questionCss = {
  ...heading5Obj,
  fontWeight: "bold",
  color: greyDark,
};

export const warningCss = {
  ...textMObj,
  color: greyDark,
};

export const iconCss = {
  height: "32px",
  width: "32px",
};
